import { render } from "./SuccessBanner.vue?vue&type=template&id=24cf3211"
import script from "./SuccessBanner.vue?vue&type=script&lang=js"
export * from "./SuccessBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__